import React from "react";

import FormSection from "../../common/FormSection";
import FormStep from "../../common/FormStep";
import LongInputField from "../../common/LongInputField";
import CheckboxField from "../../common/CheckboxField";

const businessActivitiesOptions = [
  "Analytical",
  "Architect/Engineering",
  "Construction (including construction trades)",
  "Engineering Services",
  "General Contracting",
  "Logistics",
  "IT Services",
  "Operations",
  "Maintenance",
  "Professional Services",
  "Security Services",
  "Other",
].map((option) => ({ name: option, value: option }));

const CapabilitiesFields = () => {
  return (
    <FormStep>
      <FormSection title="H. Capabilities">
        <CheckboxField
          label="1. Primary Business Activity(s)"
          name="businessActivities"
          options={businessActivitiesOptions}
        />
        <LongInputField
          label="2. States you can conduct business in"
          name="txtkStates"
        />
      </FormSection>
    </FormStep>
  );
};

export default CapabilitiesFields;
